export const actionsLocales = {
  vi: {
    create_account: 'Tạo tài khoản',
    search: 'Tra cứu',
    copy: 'Sao chép',
    copied: 'Đã sao chép',
    close: 'Đóng',
    confirm: 'Xác nhận',
    collapse: 'Thu gọn',
    expand: 'Mở rộng',
    delete: 'Xóa',
    cancel: 'Huỷ',
    ok_got_it: 'Tôi đã hiểu',
    got_it: 'Tôi đã hiểu',
    save: 'Lưu',
    clear: 'Xóa',
    clearFilter: 'Xóa bộ lọc',
    submit: 'Gửi',
  },
  en: {
    create_account: 'Create Account',
    search: 'Search',
    copy: 'Copy',
    copied: 'Copied',
    close: 'Close',
    confirm: 'Confirm',
    collapse: 'Collapse',
    expand: 'Expand',
    delete: 'Delete',
    cancel: 'Cancel',
    ok_got_it: 'OK, got it',
    got_it: 'Got it',
    save: 'Save',
    clear: 'Clear',
    clearFilter: 'Clear filter',
    submit: 'Submit',
  },
};
export type ActionsLocales = typeof actionsLocales;
